/*
//-------------------------------------------------------
//   Copyright (c) 2020 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     DateTimeTypes
//   Details:    Date time types constant
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 108238 10/06/20 JC       Added
//-------------------------------------------------------
*/

export const dateTimeTypes = {
    dateTime: 1,
    date: 2,
    time: 3
};
